export default "__VITE_ASSET__h$_Kx7O8__"